<bn-header [titulo]="titulo" [urlNavegacaoLogoBNDES]="'/prc'" [urlNavegacaoTitulo]="'./'" [isTelaLogin]="false"
           (bnAbrirPerfilCallback)="funcaoAbrirPerfil($event)"></bn-header>
<bn-alerts></bn-alerts>
<bn-loading-overlay></bn-loading-overlay>
<bn-container [exibirAside]="false">
    <bn-nav nav [itens]="getItensMenu"></bn-nav>
    <router-outlet main></router-outlet>
</bn-container>
